import { lazy, Suspense } from "react";
import Page from "@jumbo/shared/Page";
import AccessMiddleware from "./middleware/auth/AccessMiddleware";
import { DISPATCH_ADD_ROUTE, DISPATCH_EDIT_ROUTE, DISPATCH_ROUTE, DISPATCH_VIEW_ROUTE, DISPATCH_APPROVAL_VIEW_ROUTE } from "app/utils/constants/routeConstant";
import { LoadablePage } from "app/utils/loadablePage";

// Lazy load the Dispatch page
const Dispatch = lazy(() => import("app/pages/Dispatch"));
const CreateDispatch = lazy(() => import("app/pages/Dispatch/CreateDispatch"));
const ViewDispatch = lazy(() => import("app/pages/Dispatch/DispatchListing/ViewDispatchDetails/index"))
const ViewApprovalDispatch = lazy(() => import("app/pages/Dispatch/DispatchApprovalListing/ViewApprovalDispatchDetails/index"))
const EditDispatch = lazy(() => import("app/pages/Dispatch/EditDispatch/index"));
export const dispatchModuleRoute = [
  {
    middleware: [
      {
        element: AccessMiddleware,
        fallbackPath: ["/dashboard", "dispatch_permission", "view"],
      },
    ],
    routes: [
      {
        path: DISPATCH_ROUTE,
        element: LoadablePage(Dispatch),
      },
      {
        path: DISPATCH_ADD_ROUTE,
        element: LoadablePage(CreateDispatch),
      },
      {
        path: DISPATCH_VIEW_ROUTE,
        element: LoadablePage(ViewDispatch),
      },
      {
        path: DISPATCH_APPROVAL_VIEW_ROUTE,
        element: LoadablePage(ViewApprovalDispatch),
      },
      {
        path: DISPATCH_EDIT_ROUTE,
        element: LoadablePage(EditDispatch)
      }
    ],
  },
];
